import styles from './styles.module.scss';

export const PriceHighlighter = ({ isShow }) => {
  if (!isShow) return null;
  return <div className={styles.priceHighlighter} />;
};
